module.exports = __webpack_public_path__ + "static/img/p4.a6cd267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p4.jpg
// module id = Wujy
// module chunks = 1